export const alerts = state => state.alerts;
